import { IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AzureDataLakeStoreCosmosStructuredStreamFileDataset } from '../../dataset/azure-data-lake-store-cosmos-structured-stream.dataset';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';


@Metamodel.model({
    name: adfModelTypeMap.azureDataLakeStoreCosmosStructuredStream.copySourceType,
    display: [],
    tags: { datasetModel : Metamodel.modelFor(AzureDataLakeStoreCosmosStructuredStreamFileDataset)}
})
export class AzureDataLakeStoreCosmosStructuredStreamFileCopySource extends CopySource {
    public static readonly PARTITION_INDEX: IAttribute;
    @Metamodel.attribute({
        templatable: true,
        association: 'PARTITION_INDEX',
        display: stringResources.AzureDataLakeStoreCosmosStructuredStream_PartitionIndex
    })
    public partitionIndex?: number;
}
